<template>
     <div class="h-pwd_box">
        <input ref="pwd" type="pwd" :maxlength="span" v-model="msg" class="pwd" unselectable="on" @input="inputChange"/>
        <ul :class="'h-pwd-wrap h-pwd--'+size" @click="focus">
            <template v-for="(item,index) in pwdSpan" >
                <li :key="index"
                    :style=" index+1 === pwdSpan.length?'':'margin-right:'+ gutter+'px'" 
                    :class="gutter>0?'h-psd-gutter':''"
                >
                    <i v-if="msg.length > item"></i>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
export default {
    name:'h-password',
    props:{
        value:{
            type:String | Number,
            default:()=> ''
        },
        size:{
            type:String ,
            default:()=> 'small'
        },
        // 间距
        gutter:{
            type:String|Number,
            default:()=> 0
        },
        // 密码款数量
        span:{
            type:String|Number,
            default:()=> 6
        }
    },
    data() {
        return {
            msg:'',
            pwdSpan:[]
        }
    },
    mounted(){
        this.$nextTick(()=>{
            for(let i=0; i<this.span; i++){
                this.pwdSpan.push(i)
            }
        })
    },
    watch: {
        msg(curVal) {
            if(/[^\d]/g.test(curVal)) {
                this.msg = this.msg.replace(/[^\d]/g, '');
            }
        },
    },
    methods: {
         //输入支付密码
        focus() {
            this.$refs.pwd.focus();
        },
        inputChange(){
            this.$emit('input',this.msg)
        }
    }
}
</script>

<style scoped lang="less">
// 输入支付密码样式
.h-pwd_box {
    height: auto;
    display: inline-flex;
    input[type=pwd] {
        width: 0;
        height: 0;
        color: transparent;
        background: #000000;
        border: none;
        font-size: 18px;
        opacity: 0;
        z-index: -1;
    }
    //光标
    .h-psd-blink {
        // display: inline-block;
    }
    .h-pwd-wrap {
        background: #fff;
        display: flex;
        display: -webkit-box;
        display: -webkit-flex;
        cursor: pointer;
        margin: 0;
        padding: 0;
        z-index: 10;
        width: auto;
        .h-psd-gutter{
            border-radius: 4px;
            border-right: 1px solid #dcdfe6;
        }
        &.h-pwd--medium{
            li{
                height: 36px;
                width: 36px;
            }
        }
        &.h-pwd--small{
            li{
                height: 32px;
                width: 32px;
            }
        }
        &.h-pwd--mini{
            li{
                height: 28px;
                width: 28px;
            }
        }
        li {
            list-style-type: none;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            -webkit-box-flex: 1;
            width: 32px;
            height: 32px;
            flex: 1;
            -webkit-flex: 1;
            border: 1px solid #dcdfe6;
            border-right:none ;
            &:first-child{
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
            }
            &:last-child{
                border-bottom-right-radius: 4px;
                border-top-right-radius: 4px;
            }
            &:last-child {
                border-right: 1px solid #dcdfe6;
            }
            i{
                height: 5px;
                width: 5px;
                border-radius: 50%;
                background: #000;
                display: inline-block;
            }
        }
    }
}
</style>
